import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/version'
    },
    {
      path: '/version',
      component: () => import('@/views/Version.vue')
    },
    {
      path: '/task',
      component: () => import('@/views/Task.vue')
    },
    {
      path: '/frond-todo',
      component: () => import('@/views/FrondTodo.vue')
    },
    {
      path: '/test',
      component: () => import('@/views/Test.vue')
    },
    {
      path: '/story-progress',
      component: () => import('@/views/StoryProgressBoard.vue')
    },
    {
      path: '/story-kanban',
      component: () => import('@/views/story-kanban/index.vue')
    }
  ]
})
